import {Pipe, PipeTransform} from '@angular/core';
import {StagingLane} from "@services";

@Pipe({
    name: 'stagingLane',
    standalone: true
})
export class StagingLanePipe implements PipeTransform {
    transform(value: StagingLane | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case StagingLane.LaneOne: return "Lane 1";
            case StagingLane.LaneTwo: return "Lane 2";
            case StagingLane.LaneThree : return "Lane 3";
            case StagingLane.LaneFour : return "Lane 4";
            case StagingLane.LaneFive : return "Lane 5";
            case StagingLane.LaneSix : return "Lane 6";
            case StagingLane.LaneSeven : return "Lane 7";
            case StagingLane.LaneEight : return "Lane 8";
            case StagingLane.LaneNine : return "Lane 9";
            case StagingLane.LaneTen : return "Lane 10";
            case StagingLane.LaneEleven : return "Lane 11";
            case StagingLane.LaneTwelve : return "Lane 12";
            case StagingLane.LaneThirteen : return "Lane 13";
            case StagingLane.LaneFourteen : return "Lane 14";
            case StagingLane.LaneFifteen : return "Lane 15";
            case StagingLane.LaneSixteen : return "Lane 16";
            case StagingLane.LaneSeventeen : return "Lane 17";
            case StagingLane.LaneEighteen : return "Lane 18";
            case StagingLane.LaneNineteen : return "Lane 19";
            case StagingLane.LaneTwenty : return "Lane 20";
            case StagingLane.LaneTwentyOne : return "Lane 21";
            case StagingLane.LaneTwentyTwo : return "Lane 22";
            case StagingLane.LaneTwentyThree : return "Lane 23";
            case StagingLane.LaneTwentyFour : return "Lane 24";
            case StagingLane.LaneTwentyFive : return "Lane 25";
            case StagingLane.LaneTwentySix : return "Lane 26";
            case StagingLane.LaneTwentySeven : return "Lane 27";
            case StagingLane.LaneTwentyEight : return "Lane 28";
            case StagingLane.LaneTwentyNine : return "Lane 29";
            case StagingLane.LaneThirty : return "Lane 30";
            case StagingLane.LaneThirtyOne : return "Lane 31";
            case StagingLane.LaneThirtyTwo : return "Lane 32";
            case StagingLane.LaneThirtyThree : return "Lane 33";
            case StagingLane.LaneThirtyFour : return "Lane 34";
            case StagingLane.LaneThirtyFive : return "Lane 35";
            case StagingLane.LaneThirtySix : return "Lane 36";
            case StagingLane.LaneThirtySeven : return "Lane 37";
            case StagingLane.LaneThirtyEight : return "Lane 38";
            case StagingLane.LaneThirtyNine : return "Lane 39";
            case StagingLane.LaneForty : return "Lane 40";
            case StagingLane.LaneFortyOne : return "Lane 41";
            case StagingLane.LaneFortyTwo : return "Lane 42";
            case StagingLane.LaneFortyThree : return "Lane 43";
            case StagingLane.LaneFortyFour : return "Lane 44";
            case StagingLane.LaneFortyFive : return "Lane 45";
            case StagingLane.LaneFortySix : return "Lane 46";
            case StagingLane.LaneFortySeven : return "Lane 47";
            case StagingLane.LaneSOne : return "Lane S1";
            case StagingLane.LaneSTwo : return "Lane S2";
            case StagingLane.LaneSThree : return "Lane S3";
            case StagingLane.LaneSFour : return "Lane S4";
            case StagingLane.LaneSFive : return "Lane S5";
            default: return value;
        }
    }
}